import { HrbLogo } from "components/icons";
import React from "react";

export interface HeaderLogoProps {
    height?: string,
    width?: string,
    onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void
}

const HeaderLogo = (props: HeaderLogoProps) => {
    const { width, height, onClick = () => {} } = props

    const handleClick = (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        onClick(ev)
    }

    return <div className="hrb-logo-container"><HrbLogo width={width} height={height} heighthandleClick={handleClick} /></div>
}

export default HeaderLogo
